<template>
  <router-link
    tag="div"
    :to="`/viewer/${media.mediaId}`"
    class="live_info"
    :style="{ 'background-image': `url('${media.thumbnail}')` }"
  >
    <div class="live_info_top">
      <p class="live_watch_count">
        <img src="/img/view_icon.png" class="view_icon" />
        {{ watchCount }}
      </p>
      <p class="live_official">OFFICIAL</p>
    </div>
    <div class="live_info_bottom">
      <p class="live_title">{{ media.title }}</p>
      <p class="live_streamers">{{ streamerNames }}</p>
    </div>
  </router-link>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import type * as models from '@/models'

@Component({})
export default class LiveImage extends Vue {
  @Prop()
  media!: models.Media

  get streamerNames() {
    return this.media.mediaStreamers.map((v) => v.nickname).join(' ')
  }

  get watchCount() {
    return this.media.watchCount >= 1000
      ? '999+'
      : this.media.watchCount.toString()
  }
}
</script>

<style scoped>
.live_info {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 500px;
  height: calc(100% * 0.5);
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  margin: 0 0 8px 0;
}

.live_info:before {
  content: '';
  display: block;
  padding-top: 50%;
}

.live_info_top {
  display: flex;
  flex-basis: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 8px;
}

.live_watch_count {
  height: 16px;
  line-height: 16px;
  color: #ffffff;
  background-color: rgba(38, 38, 38, 0.6);
  border-radius: 4px;
  padding: 0 2px;
}

.view_icon {
  width: 16px;
  height: 16px;
  margin: 0px -3px 0 0;
  vertical-align: top;
}

.live_official {
  height: 16px;
  color: #ffffff;
  background-color: #ff003d;
  font-size: 12px;
  line-height: 10px;
  margin: 0 0 0 4px;
  padding: 3px 4px;
  border-radius: 4px;
}

.live_info_bottom {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  margin: 8px;
  padding: 0 1em 0 0;
}

.live_title {
  width: 100%;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  margin: 4px 0;
}

.live_streamers {
  width: 100%;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 130%;
}
</style>
